"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[41565],{

/***/ 111289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ NewProductImages; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _tekface_smart_activation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(560327);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92300);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55930);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(349416);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(875547);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(732324);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7297);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(888393);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var constants_smartBanner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(124177);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(316035);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _DetailPageSGC_ProductImageZoom__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(893202);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center\n  position: relative;\n  margin-bottom: 8px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  height: 388px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  aspect-ratio: 1;\n  min-width: 90px;\n  min-height: 90px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  .horizontal-slider,\n  .glide__track {\n    // 90px l\xe0 chiều dầi 1 slide (tối đa 5 silide) - 8px l\xe0 chiều d\xe0i khoảng c\xe1ch giữa c\xe1c slide (c\xf3 4 đoạn gap)\n    width: ",
        "px;\n  }\n  .glide__slide {\n    width: 90px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









const NewProductImages = ()=>{
    const { product , frame , inlineBanners  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useProductDetailState */ .W)();
    const { 0: showGallery , 1: setShowGallery  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: activeIndex , 1: setActiveIndex  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const vidRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const images = (product === null || product === void 0 ? void 0 : product.images) || [];
    const videos = (product === null || product === void 0 ? void 0 : product.videos) || [];
    const displayItems = [
        ...videos,
        ...images
    ];
    const renderDisplayItems = ()=>{
        return displayItems.map((img, index)=>{
            if (index < videos.length) {
                if (img.source === _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_3__/* .SOURCE_VIDEO.SYSTEM */ .Ok.SYSTEM) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledItemFrame, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ThumbnailVideo, {
                            url: img.url,
                            source: img.source,
                            isActive: index === activeIndex,
                            videoProps: {
                                ref: vidRef,
                                width: "100%",
                                height: "100%",
                                preload: "none",
                                playsInline: true,
                                autoPlay: true,
                                muted: true,
                                onClick: ()=>setActiveIndex(index),
                                onPlayingCapture: ()=>{
                                    var ref;
                                    return (ref = vidRef.current) === null || ref === void 0 ? void 0 : ref.pause();
                                }
                            }
                        }, index)
                    }, index);
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledItemFrame, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledYoutubeThumbnail, {
                        width: "100%",
                        height: "100%",
                        isActive: index === activeIndex,
                        youtubeLink: img.url,
                        onClick: ()=>{
                            setActiveIndex(index);
                        }
                    }, index)
                }, index);
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledItemFrame, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .SmallImage */ .K, {
                    width: "100%",
                    height: "100%",
                    borderRadius: 4,
                    borderColor: "#dddddd",
                    image: img,
                    alt: img.alt,
                    isActive: index === activeIndex,
                    borderWidth: index === activeIndex ? 1.5 : 1,
                    onClick: ()=>{
                        setActiveIndex(index);
                    }
                }, index)
            }, index);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
        isTrackContent: true,
        regionName: "imgProductDetail",
        contentName: "viewImage",
        target: "productImage",
        payload: JSON.stringify({
            sku: product === null || product === void 0 ? void 0 : product.sellerSku,
            screenName: "productDetail",
            index: activeIndex
        })
    })), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledBigImages, {
                className: "productDetailPreview" // class for pushdy banner
                ,
                children: [
                    frame && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FrameWrapper, {
                        frame: frame
                    }),
                    images || videos ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            !!inlineBanners && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tekface_smart_activation__WEBPACK_IMPORTED_MODULE_6__/* .BannerInlinePlaceholder */ .Q, {
                                banners: inlineBanners,
                                className: constants_smartBanner__WEBPACK_IMPORTED_MODULE_7__/* .INLINE_BANNER_CLASSNAME.INLINE_PDP_PREVIEW_DESK */ .h.INLINE_PDP_PREVIEW_DESK
                            }),
                            activeIndex < videos.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__/* .ProductVideo */ .N, {
                                source: videos[activeIndex].source,
                                videoProps: {
                                    preload: "none",
                                    width: "100%",
                                    height: 388,
                                    playsInline: true,
                                    muted: true,
                                    autoPlay: true,
                                    controls: true,
                                    src: videos[activeIndex].url,
                                    onClick: ()=>setShowGallery(true)
                                },
                                youtubeFrameProps: {
                                    width: "100%",
                                    height: 388,
                                    autoplay: 1,
                                    muted: true
                                },
                                url: videos[activeIndex].url
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DetailPageSGC_ProductImageZoom__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                onClick: ()=>setShowGallery(true),
                                image: images[activeIndex - videos.length],
                                height: 388
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledGlide, _objectSpreadProps(_objectSpread({
                bound: true,
                gap: 8,
                perView: 5
            }, displayItems.length <= 4 && {
                showControl: false,
                dragThreshold: false,
                swipeThreshold: false
            }), {
                displayNewLayout: true,
                children: renderDisplayItems()
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Overlay */ .a, {
                show: showGallery,
                onEscPressed: ()=>setShowGallery(false),
                children: images ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_11__/* .Gallery */ .r, {
                    images: images,
                    videos: videos === null || videos === void 0 ? void 0 : videos.map((video)=>{
                        return _objectSpreadProps(_objectSpread({}, video), {
                            src: video.url
                        });
                    }),
                    bgColor: "white",
                    onClose: ()=>setShowGallery(false),
                    activeImageIndex: activeIndex
                }) : null
            })
        ]
    }));
};
const FrameWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"].div((param)=>{
    let { frame  } = param;
    return "\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  display: flex;\n  flex-wrap: wrap;\n  background-image: url(".concat(frame, ");\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n  cursor: pointer;\n  ");
});
const StyledBigImages = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"].div(_templateObject());
const StyledYoutubeThumbnail = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .YoutubeThumbnail */ .F)((param)=>{
    let { isActive , theme  } = param;
    return "\n  border: 1.5px solid\n    ".concat(isActive ? theme === null || theme === void 0 ? void 0 : theme.colors.primary500 : "#dddddd", ";\n");
});
const ThumbnailVideo = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__/* .ProductVideo */ .N)((param)=>{
    let { isActive , theme  } = param;
    return "\n  cursor: pointer;\n  border: 1.5px solid\n    ".concat(isActive ? theme === null || theme === void 0 ? void 0 : theme.colors.primary500 : "#dddddd", ";\n  transition: 0.1s ease opacity;\n  &:hover {\n    opacity: 0.6;\n  }\n");
});
const StyledItemFrame = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"].div(_templateObject1());
const StyledGlide = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__/* .Glide */ .A)(_templateObject2(), 90 * 5 + 8 * 4);


/***/ }),

/***/ 126409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ShareAndWishlist; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(212951);
/* harmony import */ var components_WishlistButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(288257);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(316035);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(634655);
/* harmony import */ var _ShareButtons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(439764);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  ::before {\n    content: '|';\n    margin: 0 24px;\n    color: #0000000f;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






const ShareAndWishlist = ()=>{
    const { product  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useProductDetailState */ .W)();
    if (!product) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, {
        align: "bottom",
        justify: "start",
        marginBottom: "s12",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ShareButtons__WEBPACK_IMPORTED_MODULE_3__/* .ShareButtons */ .n, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Divider, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
                level: 1,
                children: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Y\xeau th\xedch")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WishlistButton__WEBPACK_IMPORTED_MODULE_6__/* .WishlistButton */ .s, {
                sku: product.sku,
                size: "24"
            })
        ]
    });
};
const Divider = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__["default"].div(_templateObject());


/***/ }),

/***/ 248225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DetailPage": function() { return /* reexport */ DetailPage/* DetailPage */.H; },
  "DetailPageSGC": function() { return /* reexport */ DetailPageSGC_DetailPage/* DetailPageSGC */.r; },
  "MAX_WIDTH": function() { return /* reexport */ DetailPageSGC_DetailPage/* MAX_WIDTH */.d; },
  "NewDetailPage": function() { return /* reexport */ NewDetailPage; }
});

// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPage/DetailPage.tsx
var DetailPage = __webpack_require__(606174);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tekface-smart-activation-virtual-e73eef34fa/0/cache/@tekface-smart-activation-npm-1.0.10-2939c41d04-992c9a64f7.zip/node_modules/@tekface/smart-activation/dist/components/InlineBannerPlaceholder.es.js
var InlineBannerPlaceholder_es = __webpack_require__(560327);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Breadcrumbs/Breadcrumbs.es.js
var Breadcrumbs_es = __webpack_require__(955006);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/NoProductsFound/NoProductsFound.es.js + 1 modules
var NoProductsFound_es = __webpack_require__(493460);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(842918);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCarousel/ProductCarousel.es.js
var ProductCarousel_es = __webpack_require__(414562);
// EXTERNAL MODULE: ./components/LazyComponent.tsx
var LazyComponent = __webpack_require__(110413);
// EXTERNAL MODULE: ./components/ProductDetail/styles.ts
var styles = __webpack_require__(243290);
// EXTERNAL MODULE: ./constants/smartBanner.ts
var smartBanner = __webpack_require__(124177);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 5 modules
var ProductDetailContext = __webpack_require__(316035);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./helpers/page-actions.ts
var page_actions = __webpack_require__(347822);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ./modules/product-detail/shared/BreadcrumbSchema.tsx
var BreadcrumbSchema = __webpack_require__(152262);
// EXTERNAL MODULE: ./modules/product-detail/shared/FlashSalePromotionBlock.tsx + 3 modules
var FlashSalePromotionBlock = __webpack_require__(981282);
// EXTERNAL MODULE: ./modules/product-detail/shared/MetaData.tsx
var MetaData = __webpack_require__(812388);
// EXTERNAL MODULE: ./modules/product-detail/shared/NewLayoutComponents/OutstandingFeatures.tsx
var OutstandingFeatures = __webpack_require__(543743);
// EXTERNAL MODULE: ./modules/product-detail/shared/NewLayoutComponents/NewPolicies.tsx
var NewPolicies = __webpack_require__(846268);
// EXTERNAL MODULE: ./modules/product-detail/shared/NewLayoutComponents/ProductInfo.tsx
var ProductInfo = __webpack_require__(534631);
// EXTERNAL MODULE: ./modules/product-detail/shared/NewLayoutComponents/ProductPrice.tsx
var ProductPrice = __webpack_require__(23704);
// EXTERNAL MODULE: ./modules/product-detail/shared/NewLayoutComponents/ProductPromotions.tsx + 1 modules
var ProductPromotions = __webpack_require__(903657);
// EXTERNAL MODULE: ./modules/product-detail/shared/NewLayoutComponents/BottomActionBar.tsx
var BottomActionBar = __webpack_require__(232757);
// EXTERNAL MODULE: ./modules/product-detail/shared/NewLayoutComponents/RelatedPosts.tsx
var RelatedPosts = __webpack_require__(786709);
// EXTERNAL MODULE: ./modules/product-detail/shared/NewLayoutComponents/RelatedVideos.tsx
var RelatedVideos = __webpack_require__(722206);
// EXTERNAL MODULE: ./modules/product-detail/shared/ProductReview/ReviewSection.tsx + 11 modules
var ReviewSection = __webpack_require__(669878);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/reflexbox-virtual-62ae8f912b/0/cache/reflexbox-npm-4.0.6-201af1058c-b532551c8b.zip/node_modules/reflexbox/dist/index.js
var dist = __webpack_require__(504545);
// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPage/new-components/NewProductImages.tsx
var NewProductImages = __webpack_require__(111289);
// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPage/new-components/ShareAndWishlist.tsx
var ShareAndWishlist = __webpack_require__(126409);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPage/NewDetailPage.tsx



















const FAQSection = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5854).then(__webpack_require__.bind(__webpack_require__, 565458)).then((mod)=>mod.FAQSection), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(565458)
            ]
    }
});
const ConfirmOver18YearOldModal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(76698), __webpack_require__.e(23540), __webpack_require__.e(28835)]).then(__webpack_require__.bind(__webpack_require__, 923540)).then((mod)=>mod.ConfirmOver18YearOldModal), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(923540)
            ]
    }
});
const ProductCombo = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(24077), __webpack_require__.e(75329), __webpack_require__.e(50343), __webpack_require__.e(67777), __webpack_require__.e(43983)]).then(__webpack_require__.bind(__webpack_require__, 243983)).then((mod)=>mod.ProductCombo), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(243983)
            ]
    }
});
const PaymentPromotion = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 575771)).then((mod)=>mod.PaymentPromotion), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(575771)
            ]
    }
});
const ProductVariants = dynamic_default()(()=>__webpack_require__.e(/* import() */ 78097).then(__webpack_require__.bind(__webpack_require__, 762782)).then((mod)=>mod.ProductVariants), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(762782)
            ]
    }
});
const RelatedPromotions = dynamic_default()(()=>__webpack_require__.e(/* import() */ 61623).then(__webpack_require__.bind(__webpack_require__, 61623)).then((mod)=>mod.RelatedPromotions), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(61623)
            ]
    }
});
const NewProductDescription = dynamic_default()(()=>__webpack_require__.e(/* import() */ 94455).then(__webpack_require__.bind(__webpack_require__, 915935)).then((mod)=>mod.NewProductDescription), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(915935)
            ]
    }
});
const NewDetailPage = (props)=>{
    var ref, ref1, ref2, ref3, ref4;
    const { product , breadcrumbs , inlineBanners , showPopupCheckAge , setShowPopupCheckAge , relatedProducts ,  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { epicOmni1550  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { showRelatedPromotion =false , extraPromotions  } = props;
    if (!product) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* NotFoundProductLayout */.DH, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoProductsFound_es/* NoProductsFound */.H, {
                show: true,
                text: (0,i18n.t)("Kh\xf4ng t\xecm thấy sản phẩm")
            })
        });
    }
    const arrowStyle = {
        backgroundColor: "white",
        borderRadius: 999,
        boxShadow: "rgba(0, 0, 0, 0.2) 0px 5px 15px"
    };
    /**
   * 690: max left container width
   * 1200: max container width
   * 16 * 2: padding left and right
   */ const leftContainerWidth = 690 / (1200 - 16 * 2) * 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbSchema/* BreadcrumbSchema */.v, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaData/* MetaData */.U, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container_es/* Container */.W, {
                marginBottom: "s16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_es/* Breadcrumbs */.O, {
                        breadcrumbs: breadcrumbs || []
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                        padding: "s16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            align: "start",
                            gap: "s24",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xu, {
                                    width: "".concat(leftContainerWidth, "%"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NewProductImages/* NewProductImages */.N, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareAndWishlist/* ShareAndWishlist */.Q, {}),
                                        !!((ref = product.seoInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.shortDescription) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(OutstandingFeatures/* OutstandingFeatures */.R, {
                                            onViewDetail: ()=>(0,page_actions/* scrollSmoothToIdWithOffset */.A)("desktop-product-description"),
                                            features: (ref2 = product.seoInfo) === null || ref2 === void 0 ? void 0 : ref2.shortDescription
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCombo, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPolicies/* NewPolicies */.B, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xu, {
                                    width: "calc(100% - ".concat(leftContainerWidth, "% - 24px)"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashSalePromotionBlock/* FlashSalePromotionBlock */._, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_es/* Card */.Z, {
                                            marginBottom: "s12",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfo/* ProductInfo */.w, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVariants, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* ProductPrice */.j, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineBannerPlaceholder_es/* BannerInlinePlaceholder */.Q, {
                                                    banners: inlineBanners,
                                                    className: smartBanner/* INLINE_BANNER_CLASSNAME.INLINE_PDP_RELATEDPROMO */.h.INLINE_PDP_RELATEDPROMO
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPromotions/* ProductPromotions */._, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomActionBar/* BottomActionBar */.G, {}),
                                        showRelatedPromotion && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedPromotions, {
                                                extraPromotions: extraPromotions
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentPromotion, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            gap: "s16",
                            marginTop: "s16",
                            align: "start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xu, {
                                    width: "784px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewProductDescription, {
                                            tabTitle: [
                                                (0,i18n.t)("Th\xf4ng số kỹ thuật"),
                                                (0,i18n.t)("Chi tiết sản phẩm")
                                            ],
                                            buttonType: "ghost"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xu, {
                                    width: "calc(100% - 784px - 16px)",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                        direction: "column",
                                        gap: "s8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedPosts/* RelatedPosts */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedVideos/* RelatedVideos */.Z, {})
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    epicOmni1550 && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                            marginTop: "s16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewSection.ReviewSection, {})
                        })
                    }),
                    !!((ref3 = product.seoInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.faq) === null || ref4 === void 0 ? void 0 : ref4.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                            marginTop: "s16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection, {
                                faq: product.seoInfo.faq,
                                style: {
                                    padding: "0px"
                                }
                            })
                        })
                    }),
                    relatedProducts.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_es/* Card */.Z, {
                            marginTop: "s16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader_es/* BlockHeader */.t, {
                                    title: (0,i18n.t)("Sản phẩm li\xean quan")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_es/* ProductCarousel */.G, {
                                    products: relatedProducts,
                                    productsPerRow: 5,
                                    regionName: "relatedProducts",
                                    virtual: (0,helpers/* isServerless */.ep)(),
                                    customStyleLeftArrow: arrowStyle,
                                    customStyleRightArrow: arrowStyle
                                })
                            ]
                        })
                    }) : null
                ]
            }),
            showPopupCheckAge && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmOver18YearOldModal, {
                showPopupCheckAge: showPopupCheckAge,
                setShowPopupCheckAge: setShowPopupCheckAge,
                okText: (0,i18n.t)("T\xf4i tr\xean 18 tuổi")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPage/index.ts



// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPageSGC/DetailPage.tsx + 11 modules
var DetailPageSGC_DetailPage = __webpack_require__(483531);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/index.ts


;// CONCATENATED MODULE: ./modules/product-detail/desktop/index.ts




/***/ }),

/***/ 543743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ OutstandingFeatures; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(391547);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dompurify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(634655);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #f9f9f9;\n  border-radius: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 24px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20px;\n  overflow: hidden;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




const OutstandingFeatures = (param)=>{
    let { features , onViewDetail ,  } = param;
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledHeader, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTitle, {
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Đặc điểm nổi bật")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                        variant: "link",
                        onClick: onViewDetail,
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Xem th\xf4ng tin chi tiết")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledContent, {
                dangerouslySetInnerHTML: {
                    __html: (dompurify__WEBPACK_IMPORTED_MODULE_1___default()) === null || (dompurify__WEBPACK_IMPORTED_MODULE_1___default()) === void 0 ? void 0 : (ref = (dompurify__WEBPACK_IMPORTED_MODULE_1___default().sanitize)) === null || ref === void 0 ? void 0 : ref.call((dompurify__WEBPACK_IMPORTED_MODULE_1___default()), features)
                }
            })
        ]
    });
};
const StyledWrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.borderRadius.m;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.s8;
});
const StyledHeader = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.spacing.s8;
});
const StyledTitle = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__["default"].span(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.textTitle;
});
const StyledContent = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.textPrimary;
});


/***/ }),

/***/ 324041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ groupAttributes; },
/* harmony export */   "D": function() { return /* binding */ isShowRetailPrice; }
/* harmony export */ });
const groupAttributes = (attributes)=>{
    const parentAttributes = attributes.filter((att)=>att.parentId === 0) || [];
    const mapAtttributes = new Map(parentAttributes.map((att)=>[
            att.id,
            []
        ]));
    attributes.forEach((att)=>{
        if (att.parentId === 0 || !att.value) return;
        const children = mapAtttributes.get(att.parentId);
        if (children) {
            children.push(att);
            mapAtttributes.set(att.parentId, children);
        }
    });
    let displayAttributes = [];
    parentAttributes.forEach((att)=>{
        const children = mapAtttributes.get(att.id) || [];
        if (!!children.length) {
            displayAttributes.push(att);
            displayAttributes = [
                ...displayAttributes,
                ...children
            ];
        }
    });
    return displayAttributes;
};
const isShowRetailPrice = (supplierRetailPrice, latestPrice)=>{
    let newSupplierRetailPrice = supplierRetailPrice;
    let newLatestPrice = latestPrice;
    if (typeof supplierRetailPrice === "string") {
        newSupplierRetailPrice = supplierRetailPrice.replace(/[₫đ.]/g, "");
    }
    if (typeof latestPrice === "string") {
        newLatestPrice = latestPrice.replace(/[₫đ.]/g, "");
    }
    return Number(newSupplierRetailPrice) > Number(newLatestPrice);
};


/***/ }),

/***/ 606764:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var Variant = /* @__PURE__ */ ((Variant2) => {
  Variant2["primary"] = "primary";
  Variant2["secondary"] = "secondary";
  Variant2["ghost"] = "ghost";
  Variant2["link"] = "link";
  return Variant2;
})(Variant || {});
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["left"] = "left";
  Alignment2["center"] = "center";
  Alignment2["right"] = "right";
  Alignment2["justify"] = "justify";
  return Alignment2;
})(Alignment || {});
var VerticalAlignment = /* @__PURE__ */ ((VerticalAlignment2) => {
  VerticalAlignment2["top"] = "top";
  VerticalAlignment2["center"] = "center";
  VerticalAlignment2["bottom"] = "bottom";
  return VerticalAlignment2;
})(VerticalAlignment || {});
var DSSize = /* @__PURE__ */ ((DSSize2) => {
  DSSize2["small"] = "small";
  DSSize2["medium"] = "medium";
  DSSize2["default"] = "default";
  DSSize2["large"] = "large";
  return DSSize2;
})(DSSize || {});
var DividerTypeEnum = /* @__PURE__ */ ((DividerTypeEnum2) => {
  DividerTypeEnum2["text"] = "text";
  DividerTypeEnum2["icon"] = "icon";
  return DividerTypeEnum2;
})(DividerTypeEnum || {});
var DividerStyleEnum = /* @__PURE__ */ ((DividerStyleEnum2) => {
  DividerStyleEnum2["solid"] = "solid";
  DividerStyleEnum2["double"] = "double";
  DividerStyleEnum2["dotted"] = "dotted";
  DividerStyleEnum2["dashed"] = "dashed";
  return DividerStyleEnum2;
})(DividerStyleEnum || {});

exports.Alignment = Alignment;
exports.DSSize = DSSize;
exports.DividerStyleEnum = DividerStyleEnum;
exports.DividerTypeEnum = DividerTypeEnum;
exports.Variant = Variant;
exports.VerticalAlignment = VerticalAlignment;


/***/ }),

/***/ 414951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var _enum = __webpack_require__(606764);



__webpack_unused_export__ = _enum.Alignment;
__webpack_unused_export__ = _enum.DSSize;
exports.fd = _enum.DividerStyleEnum;
__webpack_unused_export__ = _enum.DividerTypeEnum;
__webpack_unused_export__ = _enum.Variant;
__webpack_unused_export__ = _enum.VerticalAlignment;


/***/ })

}]);